import { FormGroup, FormHelperText, FormLabel, Grid } from '@mui/material';
import CustomTextValidator from 'common/components/CustomTextValidators';
import useStylesForm from 'common/components/styles/useStylesForm.styles';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useTranslation } from 'react-i18next';

import useFlexBoxStyles from 'common/flexBox';
import NumberFormatCustom from '../../../common/components/NumberFormatCustom';
import useStylesProductForm from '../styles/useStylesProductForm.styles';

const ProductFormCommon = (props) => {
    const { fields, handleFieldChange, decimalScale, readOnly } = props;
    const { t } = useTranslation();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: classes1 } = useStylesForm();
    const { classes: classes2 } = useStylesProductForm();
    const classes = { ...classes1, ...classes2 };

    return (
        <Grid container spacing={1}>
            <Grid item md={12}>
                {fields.externalId !== '0' && (
                    <FormGroup className={classes.formGroup}>
                        <FormLabel>{t('product.productFormCommon.externalId')}</FormLabel>
                        <CustomTextValidator
                            InputProps={{
                                readOnly: readOnly,
                            }}
                            name="externalId"
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            value={fields.externalId}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                )}
            </Grid>
            <Grid item md={3}>
                <FormGroup className={classes.formGroup}>
                    <FormLabel>{t('product.productFormCommon.availability')}</FormLabel>
                    <CustomTextValidator
                        name="stock"
                        fullWidth={true}
                        value={fields.stock || 0}
                        onChange={handleFieldChange}
                        variant="outlined"
                        size="small"
                        placeholder={t('product.productFormCommon.availabilityPlaceholder')}
                        type="number"
                        InputProps={{
                            inputProps: { min: 0 },
                            readOnly: readOnly,
                        }}
                        validators={[`minNumber:1`, 'required']}
                        errorMessages={[
                            t('product.productFormCommon.errorMinStock'),
                            t('product.productFormCommon.availabilityRequired'),
                        ]}
                    />
                </FormGroup>
            </Grid>
            <Grid item md={3}>
                <FormGroup className={classes.formGroup}>
                    <FormLabel>{t('product.productFormCommon.price')}</FormLabel>
                    <CustomTextValidator
                        name="price"
                        fullWidth={true}
                        InputProps={{
                            inputProps: { min: 0, decimalScale },
                            inputComponent: NumberFormatCustom,
                            startAdornment: (
                                <span style={{ marginRight: '2px' }}> {getSymbolFromCurrency(fields.currency)}</span>
                            ),
                            readOnly: readOnly,
                        }}
                        value={fields.price}
                        onChange={handleFieldChange}
                        readOnly={true}
                        variant="outlined"
                        size="small"
                        placeholder={'0'}
                        validators={['required']}
                        errorMessages={[t('product.productFormCommon.priceRequired')]}
                    />
                </FormGroup>
            </Grid>
            <Grid item md={6}>
                <FormGroup className={classes.formGroup}>
                    <FormLabel>{t('product.productFormCommon.link')}</FormLabel>
                    <CustomTextValidator
                        name="url"
                        fullWidth={true}
                        variant="outlined"
                        size="small"
                        autoComplete="new-link"
                        value={fields.url}
                        onChange={handleFieldChange}
                        placeholder={t('product.productFormCommon.linkPlaceholder')}
                        validators={['required', 'urlMatch']}
                        errorMessages={[
                            t('product.productFormCommon.linkRequired'),
                            t('product.productFormCommon.linkInvalid'),
                        ]}
                        InputProps={{
                            readOnly: readOnly,
                        }}
                    />
                    {fields.broken && fields.url === fields.brokenUrl ? (
                        <FormHelperText className={flexBox.paddingLeft2} error>
                            {t('product.productItem.brokenProductUrl')}
                        </FormHelperText>
                    ) : null}
                </FormGroup>
            </Grid>
        </Grid>
    );
};

export default ProductFormCommon;
